"use strict";const n=10,e=t=>Array.isArray(t)?t.filter(r=>!!r).flat(10).join(" "):t;export default e;
//# sourceMappingURL=getStylesString.js.map
